import { NgModule } from "@angular/core";
import { SharedModule } from "../../../shared/shared.module";

import { CommunityViewerRoutingModule } from "./community-viewer-routing.module";

import { CommunityViewerComponent } from "./community-viewer.component";
import { CommunityNavTabsComponent } from "./community-nav-tabs/community-nav-tabs.component";
import { LatestDiscussionsComponent } from "./latest-discussions/latest-discussions.component";
import { TrendingDiscussionsComponent } from "./trending-discussions/trending-discussions.component";
import { CommunityCardComponent } from "./community-card/community-card.component";
import { ViewableCommunityResolver } from "../../../shared/services";

@NgModule({
  imports: [CommunityViewerRoutingModule, SharedModule],
  declarations: [
    CommunityViewerComponent,
    CommunityNavTabsComponent,
    LatestDiscussionsComponent,
    TrendingDiscussionsComponent,
    CommunityCardComponent,
  ],
  providers: [ViewableCommunityResolver],
})
export class CommunityViewerModule {}
